/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../_dashboard/assets/ts/components'
import {ID, KTSVG, QUERIES} from '../../../../../../_dashboard/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import { deleteOne } from '../../../../../services/common_requests'
import { useIntl } from 'react-intl'
import { ThemeEditModal } from '../../themes-edit-modal/ThemeEditModal'
import {toast} from 'react-toastify'
import {useAuth} from '../../../../../modules/auth'
import { useConfirm } from '../../../../../components/ConfirmProvider'

type Props = {
  id: ID
}
const ThemeActionsCell: FC<Props> = ({id}) => {
  const [showModal, setShowModal] = useState(false)
  const {auth} = useAuth()
  const confirm = useConfirm()

  const intl = useIntl();
  const {setItemIdForUpdate} = useListView()
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()
  const {refetchData} = useQueryResponse()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const deleteItem = useMutation(() => deleteOne(id,'/themes'), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.THEMES_LIST}-${query}`])
      toast.success(
        intl.formatMessage({
          id: 'ADMIN.COMMON.SUCCESS.THEMES_DELETED_SUCCESSFULLY',
        }),
        {
          position: 'top-right',
          autoClose: 4000,
        }
      )
      refetchData()
    },
    onError: () => {
      toast.error(
        intl.formatMessage({
          id: 'ADMIN.COMMON.ERROR.ERROR_DELETING_THEMES',
        }),
        {
          position: 'top-right',
          autoClose: 4000,
        }
      )
    },
  })
  return (
    <>
      <a
        href='#'
        className='btn btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
              <KTSVG path='/media/icons/duotune/arrows/Threedots.svg' className='svg-icon-5 m-0' />

      </a>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-1'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            {intl.formatMessage({id:'ACTION.EDIT'})}
          </a>
        </div>
        {auth?.role === 'ROLE_SUPER_ADMIN' && (
          <div className='menu-item px-3'>
            <a
              className='menu-link px-3'
              data-kt-users-table-filter='delete_row'
              onClick={async () => {
                const ok = await confirm({})
                if (!ok) return
                await deleteItem.mutateAsync()
              }}
            >
              {intl.formatMessage({id:'ACTION.DELETE'})}
            </a>
          </div>
        )}
      </div>
      {showModal && <ThemeEditModal />}
    </>
  )
}

export {ThemeActionsCell}
